import './i18n/index';
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import { ThemeProvider, useTheme } from './theme/ThemeContext';
import { buildMuiTheme } from './theme/muiTheme';

function ThemedApp() {
  const { theme } = useTheme();
  const muiTheme = useMemo(() => buildMuiTheme(theme), [theme]);
  return (
    <MuiThemeProvider theme={muiTheme}>
      <App />
    </MuiThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  </React.StrictMode>
);
